const checkoutNotExists = ` <div class="modal-header-wrapper" role="alert">  
        <a href="" role="button" class="close-modal"><i class="icon-close"></i></a>
        <p class="lead">Não existe compra em andamento, por favor faça uma busca e inicie uma compra.</p>
    </div>
    <div class="btn-group">           
        <a href="/" title="Voltar pra home" class="btn btn-success btn-large"><i class="icon-arrow-right"></i> OK</a>
    </div>`;

const notAutorized = ` <div class="modal-header-wrapper" role="alert">  
        <a href="" role="button" class="close-modal"><i class="icon-close"></i></a>
        <p class="lead">Por favor, faça login.</p>
    </div>
    <div class="btn-group">           
        <button title="Ir para página de login" id="proceed_to_login" class="btn btn-success btn-large"><i class="icon-arrow-right"></i> Fazer login</button>
    </div>`;

const checkoutExpired = `<div class="modal-header-wrapper" role="alert">  
        <!--<a href="" role="button" class="close-modal"><i class="icon-close"></i></a>-->
        <p class="lead">Compra expirada. Tente novamente.</p>
    </div>
    <div class="btn-group">           
        <button title="Voltar pra home" id="btn_expired" class="btn btn-success btn-large"><i class="icon-arrow-right"></i> OK</button>
    </div>`;

const checkoutDefaultError = `<div class="modal-header-wrapper" role="alert">  
        <a href="" role="button" class="close-modal"><i class="icon-close"></i></a>
        <p class="lead">Oops, ocorreu um erro inesperado. Por favor, tente novamente.</p>
    </div>
    <div class="btn-group">           
        <button title="Ok" id="try_again" class="btn btn-success btn-large"><i class="icon-arrow-right"></i> OK</button>
    </div>`;

export const checkoutErrorsGET = {
	checkoutNotExists: {
		content: checkoutNotExists,
		hooks: null
	},
	checkoutExpired: {
		content: checkoutExpired,
		hooks: () => {
			const btnExpired = document.getElementById("btn_expired");

			if (btnExpired !== null) {
				btnExpired.onclick = event => {
					event.preventDefault();
					window.sessionStorage.removeItem("activeCheckoutId");
					window.location.pathname = "/";
				};
			}
		}
	},
	notAutorized: {
		content: notAutorized,
		hooks: () => {
			const loginBtn = document.getElementById("proceed_to_login");

			if (loginBtn !== null) {
				loginBtn.onclick = event => {
					event.preventDefault();
					localStorage.removeItem("au");
					window.location.pathname = "/login";
				};
			}
		}
	},
	checkoutDefaultError: {
		content: checkoutDefaultError,
		hooks: () => {
			const tryAgainBtn = document.getElementById("try_again");

			if (tryAgainBtn !== null) {
				tryAgainBtn.onclick = event => {
					event.preventDefault();
					window.location.reload(true);
				};
			}
		}
	}
};
